import { OBJECT_TYPE_HALL } from '%paysera_seat_selection/js/seatSelection/config/constants';
import getSeatingMapObjectParent from '%paysera_seat_selection/js/seatSelection/services/getSeatingMapObjectParent';

function getObjectParentChainUpToHall(object) {
    const parent = getSeatingMapObjectParent(object);
    let grandParents = [];
    if (parent !== null && parent.objectType !== OBJECT_TYPE_HALL) {
        grandParents = getObjectParentChainUpToHall(parent);
    }

    return [...grandParents, parent].filter(Boolean);
}

export default getObjectParentChainUpToHall;
